export default "__VITE_ASSET__4EtHKt4X__"